import { IconButton } from "@mui/material";
import { StyledTableCell } from "../Styled";
import MoreVertIcon from "@mui/icons-material/MoreVert";


export const RenderMenuCell = ({ isNewRow, hasRowOptions, hasMainOtherMenu, onRowMenuSelect = () => { } }) => {
    if (!isNewRow && (hasRowOptions || hasMainOtherMenu)) {
        return (
            <StyledTableCell size="small">
                <IconButton
                    size="small"
                    aria-label="settings"
                    onClick={onRowMenuSelect}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </StyledTableCell>
        );
    } else if (!isNewRow && hasMainOtherMenu) {
        return <StyledTableCell size="small" />;
    } else if (hasRowOptions) {
        return <StyledTableCell size="small" />;
    }
    return null;
};